import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20.333 10.333H7.677l5.503-5.479A1.671 1.671 0 0 0 11.996 2c-.444 0-.87.176-1.184.49l-8.337 8.326q-.229.24-.35.55c-.167.405-.167.86 0 1.265.08.205.198.392.35.55l8.337 8.326a1.666 1.666 0 0 0 2.368 0 1.666 1.666 0 0 0 0-2.364l-5.503-5.48h12.656A1.67 1.67 0 0 0 22 12a1.664 1.664 0 0 0-1.667-1.666"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }